import { useContext } from 'react';
import { Box, DeleteModal, Flex, ModalContext, Text } from 'dash-ui';

import {
  GetOrganizationsForSelectDocument,
  GetOrganizationsForTableDocument,
  GetPropertiesDocument,
  useDeleteOrganizationMutation,
} from 'gql/generated.graphql';
import { useTranslation } from 'react-i18next';
import { OrganizationModals } from 'pages/organizations/constants/constants';

function ConfirmationDeleteOrganizationModal() {
  const { payload, toggleModal } = useContext(ModalContext);
  const { t } = useTranslation(['common', 'pages']);

  const [removeOrganization, { loading }] = useDeleteOrganizationMutation({
    refetchQueries: [
      GetPropertiesDocument,
      GetOrganizationsForSelectDocument,
      GetOrganizationsForTableDocument,
    ],
  });

  async function submitMarketAreaDelete() {
    await removeOrganization({
      variables: {
        organizationId: payload?._id,
      },
    });
    toggleModal(false, OrganizationModals.CONFIRMATION_DELETE_ORGANIZATION);
  }

  return (
    <DeleteModal
      title={t('modalDelete.confirmationTextSecond', { entity: 'Organization' }) || ''}
      entity="Organization"
      message={
        <Flex flexDirection="column">
          <Text>{t('modalConfirmDelete.actionUnassing')}<strong>{payload?.name}</strong>{t('modalConfirmDelete.propertiesCurrentAssigned', {
            entity: 'Organization'
          })}</Text>
          <Box my={2} />
          <Text>{t('modalConfirmDelete.ProceedDeletion')}</Text>
        </Flex>
      }
      name={payload?.name}
      isLoading={loading}
      modalName={OrganizationModals.CONFIRMATION_DELETE_ORGANIZATION}
      onClick={submitMarketAreaDelete}
    />
  );
}

export default ConfirmationDeleteOrganizationModal;
